"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionLookup = void 0;
exports.RegionLookup = {
    west: "west",
    northeast: "northeast",
    midwest: "midwest",
    southeast: "southeast",
    texas: "texas",
    uncategorized: "uncategorized",
};
//# sourceMappingURL=SellerConfig.js.map